import { createButton } from "../Button/createButton";

export const TabButton = createButton({
  className: "text-center rounded-none flex-1 whitespace-nowrap",
  role: "tab",
  selectedClassName: "text-selected-tab",
});
